<template>
    <v-dialog persistent v-model="get_dialogSecoundMain.dialog" width="800px" justify-center>
        <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title>
                <h3 v-if="get_dialogSecoundMain.type == 'create'">Nuevo Asignacion de Role </h3>
                <h3 v-else>Editar Asigncion de Role </h3>
            </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn icon dark @click="HIDDE_DIALOG_SECOUND_MAIN()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card width="auto" tile>
            <v-form ref="form">
                <v-card-text>
                    <v-row dense>
                        <v-col cols="6">
                            <p><label class="font-weight-bold">Nombre: </label> {{model.nombre}}</p>
                        </v-col>
                        <v-col cols="6">
                            <p><label class="font-weight-bold">Usuario: </label> {{model.usuario}}</p>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                            v-model="role.rol_id"
                                label="Roles"
                                :items="get_objectsSecound"
                                :rules="fieldRequired"
                                item-text="nombre"
                                item-value="id"
                                outlined
                                dense>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-layout justify-end>
                    <v-btn class="red darken-1 mr-3" dark @click="HIDDE_DIALOG_SECOUND_MAIN()">Cancelar</v-btn>
                    <v-btn class="green darken-1 mr-3" dark @click="save"> Guardar</v-btn>
                    </v-layout>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
export default {
  props: ['model'],
  mixins: [Validate],
  data: () => ({
    role: {}
  }),
  components: {
  },
  mounted () {
    this.getUrlRoles('rol.list')
  },
  methods: {
    ...mapActions(['getUrlServices', 'postUrlServicesAction', 'postUrlServicesListActionSecound']),
    getUrlRoles (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServicesListActionSecound({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    save () {
      this.role.id = this.model.id
      this.getUrl('usr.set-rol')
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServicesAction({ url: router, data: this.role })
      } else {
        this.getUrlServices()
      }
    },
    cancel () {
      this.HIDDE_DIALOG_SECOUND_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_SECOUND_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogSecoundMain', 'get_urls', 'get_objectsSecound', 'get_object'])
  },
  watch: {
    get_urls () {
      this.getUrlRoles('rol.list')
    },
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'El usuario ha sido vinculada con el Rol'
      })
      this.cancel()
    }
  }
}
</script>

<style>

</style>
